import { render, staticRenderFns } from "./CiudadExport.vue?vue&type=template&id=189c9fac"
import script from "./CiudadExport.vue?vue&type=script&lang=js"
export * from "./CiudadExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports